import { render, staticRenderFns } from "./ApplicationCreated.vue?vue&type=template&id=7d427ffa&"
import script from "./ApplicationCreated.vue?vue&type=script&lang=ts&"
export * from "./ApplicationCreated.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ApplicationCreated.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports